module.exports = __webpack_public_path__ + "static/mivors-logo-e3b31dd83ae5ddfc87555436e020588e.png";